import axios from "axios";
import { API_URL } from "./config";
import store from "@/store";

// Configurar base URL
axios.defaults.baseURL = API_URL;

// Interceptor para agregar el IdEmpleado en cada petición
axios.interceptors.request.use(
  (config) => {
    const user = store.getters.getUser;
    if (user && user.IdEmpleado) {
      config.headers["X-User-Id"] = user.IdEmpleado;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// Pantallas que operan SIN sesión (cocina, barra, menú por QR y detalle de
// reserva). Un 401 en ellas no significa "sesión expirada": significa que se
// llamó un endpoint que pide auth. Expulsarlas al login deja a la cocina sin
// comandas hasta que alguien vuelva a abrir la pantalla a mano.
//
// Se compara contra la URL del navegador y no contra el router para no crear
// una dependencia circular (el router importa el store, que importa esto).
const RUTAS_PUBLICAS = [
  "/pantalla-cocina-publica",
  "/pantalla-barra-publica",
  "/menu/",
  "/ver-detalle-publico/",
];

const enRutaPublica = () =>
  RUTAS_PUBLICAS.some((ruta) => window.location.pathname.startsWith(ruta));

// Interceptor para manejar errores de autorización
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 403) {
      // Usuario no tiene permisos - NO usar alert, solo rechazar el error
      // El componente individual debe manejar este error apropiadamente
      console.warn("Acceso denegado:", error.response?.data?.message);
    } else if (error.response && error.response.status === 401) {
      // Usuario no autenticado - solo si viene del backend de manera legítima
      // NO mostrar alert en caso de credenciales incorrectas en login
      const isLoginError = error.config?.url?.includes("/login");

      if (enRutaPublica()) {
        // El redirect es un window.location.href, así que se salta el guard
        // del router y su meta.publica. La comprobación tiene que estar aquí.
        console.warn(
          "401 en una pantalla pública; no se cierra sesión:",
          error.config?.url,
        );
      } else if (!isLoginError) {
        console.warn("Sesión expirada");
        store.dispatch("logout");
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  },
);

export default axios;
